import { useState, useEffect } from 'react'
import styled from 'styled-components'
import { TransparentButton } from 'common/button'
import { ArrowBottom } from 'icons/arrow'
import { MdCheckBoxOutlineBlank, MdCheckBox } from 'react-icons/md'
import { useRouter } from 'next/router'

const FilterListStyled = styled.div`
  position: relative;
  padding: 2px 8px;
  ${({ isOpen }) => isOpen && `
    background: var(--neutral90);
  `}
  .filter-title {
    font: var(--regularBold);
  }
  svg {
    margin-inline-start: 4px;
    transition: 0.1s ease-in;
  }
  .options-list {
    position: absolute;
    left: 0px;
    z-index: 1;
    background: var(--neutral90);
    border-radius: 8px 0px 8px 8px;
  }
  .option-item {
    font: var(--p2Regular);
    gap: 16px;
    padding: 12px 16px;
  }
  button {
    width: 100%;
    justify-content: space-between;
    text-align: left;
  }
  @media (min-width: 768px) {
    .options-list {
      left: initial;
      right: 0px;
      min-inline-size: 250px;
    }
    .option-item {
      gap: 0px;
    }
  }
`

function FilterList({ id, title, type, options, isOpen, handleOpen }) {
  const router = useRouter()
  const [checked, setChecked] = useState('')

  useEffect(() => {
    const querys = Object.values(router.query)
    if (!querys.includes(checked)) {
      setChecked('')
    }
  }, [router.query])

  const handleOption = (param) => {
    const url = window.location.pathname
    const querys = { ...router.query }
    if (param !== checked) {
      setChecked(param)
      querys[type] = param
    } else {
      setChecked('')
      delete querys[type]
    }
    router.replace({
      pathname: url,
      query: querys,
      shallow: true,
      scroll: false,
    })
  }
  return (
    <FilterListStyled isOpen={isOpen}>
      <div className="filter-title">
        <TransparentButton onClick={() => handleOpen(id)}>
          {title}
          <ArrowBottom color="var(--baseSecondary)" />
        </TransparentButton>
      </div>
      {isOpen && (
        <ul className="options-list">
          {options.map(({ param, option }) => (
            <li key={param}>
              <TransparentButton className="option-item" onClick={() => handleOption(param)}>
                {option}
                {checked === param ? (
                  <MdCheckBox color="var(--turquoise)" size={24} />
                ) : (
                  <MdCheckBoxOutlineBlank color="var(--turquoise)" size={24} />
                )}
              </TransparentButton>
            </li>
          ))}
        </ul>
      )}
    </FilterListStyled>
  )
}

export default FilterList
